__turbopack_context__.v({
  "blocksBackgroundColor": "PollBlock-module-scss-module__LmDcXq__blocksBackgroundColor",
  "blocksFontColor": "PollBlock-module-scss-module__LmDcXq__blocksFontColor",
  "button": "PollBlock-module-scss-module__LmDcXq__button",
  "loading": "PollBlock-module-scss-module__LmDcXq__loading",
  "pollEdit": "PollBlock-module-scss-module__LmDcXq__pollEdit",
  "secondaryNavBackgroundColor": "PollBlock-module-scss-module__LmDcXq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "PollBlock-module-scss-module__LmDcXq__themeBackgroundColor",
  "themeFontColor": "PollBlock-module-scss-module__LmDcXq__themeFontColor",
  "themeFontFamily": "PollBlock-module-scss-module__LmDcXq__themeFontFamily",
});
